module.exports = __webpack_public_path__ + "img/istanbul-street.c93d6c1c.jpg";